import React, { useState, useContext, useEffect } from "react";

import { Check } from "react-feather";

import { FormTextInput } from "../../../Components/FormTextInput";
import { languages } from "../../../Data/languages";
import { useScreenTransition } from "../../../Hooks/useScreenTransition";
import { AuthContext } from "../../../Context/AuthContext";
import { NotificationContext } from "../../../Context/NotificationContext";
import { DataContext } from "../../../Context/DataContext";
import TopBar from "../../../Components/TopBar";
import PopUpModal from "../../../NewComponents/PopUpModal";
import LogoAuthNavbar from "../../../NewComponents/LogoAuthNavbar";
import CreateOrderNav from "../../../NewComponents/CreateOrderNav";
import NewButton from "../../../NewComponents/NewButton";
import { ReactComponent as NOTRY } from "../../../assets/icons/Notarization.svg";
import { ReactComponent as EXPEDITED } from "../../../assets/icons/expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../../assets/icons/HardCopy.svg";
import { ReactComponent as QUOTESUCCESS } from "../../../assets/icons/quote-success.svg";
import { ReactComponent as CHECK } from "../../../assets/icons/business.svg";
import { ReactComponent as MORESELECTED } from "../../../assets/icons/More-selected.svg";
import { ReactComponent as ADDRESS } from "../../../assets/icons/Address.svg";
import SearchSelect from "../../../NewComponents/SearchSelect";
import { expeditedPlusLanguages } from "../../../Data/ExpeditePlusLanguages";
import { v4 as uuidv4 } from "uuid";
import {
  decrTeamFreeExpedOrder,
  formatTotal,
  getDiscount,
  getExpedited,
  getHardCopyPrice,
  getOrderPageCountTotal,
  getTotal,
} from "../../../Data/Functions";
import { Country, State, City } from "country-state-city";

import "../../Order/OrderOptions.css";
import "../QuoteDetails.css";
import CountrySelect from "../../../NewComponents/CountrySelect";
import CitySelect from "../../../NewComponents/CitySelect";
import axios from "axios";
import SendPaymentLinkPopUp from "../../../NewComponents/SendPaymentLinkPopUp";
import { useSpring, animated } from "react-spring";
import { firestore, getFullHttpUrl } from "../../../firebase.config";
import { getCounter } from "../../../Data/Functions/getCounter";
import SelectSearch from "../../../NewComponents/select-search";
import { EAST1 } from "../../../utility/enums";

export const USPriorDelivery = [
  {
    label: "USPS Priority: 2-3 days - $19.95",
    value: "priority",
  },
  {
    label: "USPS Express: 1-2 days - $37.95",
    value: "express",
  },
];

export const otherCitiesDelivery = [
  {
    label: "USPS Priority: 6-10 days - $49.95",
    value: "priority",
  },
  {
    label: "USPS Express: 3-5 days - $78.95",
    value: "express",
  },
];

const QuoteService = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { manualQuote, setManualQuote } = useContext(DataContext);

  const [discountCode, setDiscountCode] = useState("");
  const [discountBtn, setDiscountBtn] = useState("Apply");
  const [storeQuote, setStoreQuote] = useState(null);
  const [storeOrder, setStoreOrder] = useState(null);

  const [notarization, setNotarization] = useState(false);
  const [expedited, setExpedited] = useState(false);
  const [expeditedPlus, setExpeditedPlus] = useState(false);
  const [hardCopy, setHardCopy] = useState(false);

  const [hardCopyCountry, setHardCopyCountry] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [hardCopyMethod, setHardCopyMethod] = useState("");
  const [hardCopyRequireSignature, setHardCopyRequireSignature] = useState(false);

  const [openQuoteModel, setOpenQuoteModel] = useState(false);
  const [createQuoteText, setCreateQuoteText] = useState("Create Quote");
  const [createOrderText, setCreateOrderText] = useState("Create Order");

  const [selectedQuoteSendPayment, setSelectedQuoteSendPayment] = useState("");
  const [selectedOrderSendPayment, setSelectedOrderSendPayment] = useState("");
  const [loadingModal, setLoadingModal] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const statusOverlayProps = useSpring({
    display: isLoading ? "flex" : "none",
  });

  const [hardCopyFirstName, setHardCopyFirstName] = useState("");
  const [hardCopyLastName, setHardCopyLastName] = useState("");
  const [hardCopyState, setHardCopyState] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [hardCopyCity, setHardCopyCity] = useState("");
  const [hardCopyZipCode, setHardCopyZipCode] = useState("");
  const [hardCopyStreet, setHardCopyStreet] = useState("");
  const [hardCopyApartment, setHardCopyApartment] = useState("");
  const [newAddressModal, setNewAddressModal] = useState(false);
  const [editAddressIconSelected, setEditAddressIconSelected] = useState("");
  const [openOrderModel, setOpenOrderModel] = useState(false);

  const [saveAddress, setSaveAddress] = useState(false);
  const [addressName, setAddressName] = useState("");
  const [discount, setDiscount] = useState(0);
  const [appliedCode, setAppliedCode] = useState("");
  const [selectedMyAddress, setSelectedMyAddress] = useState("");
  const [selectedMyCountry, setSelectedMyCountry] = useState("");
  const [selectedMyMethod, setSelectedMyMethod] = useState("");
  const [editAddress, setEditAddress] = useState("");
  const [deleteModalAddress, setDeleteModalAddress] = useState(null);
  const [deleteBtnText, setDeleteBtnText] = useState('Delete Address');
  
  const [translatorCertify, setTranslatorCertify] = useState(false);
  const [manuallyPaid, setManuallyPaid] = useState(false);
  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");

  const [editFirstName, setEditFirstName] = useState("");
  const [editLastName, setEditLastName] = useState("");
  const [editState, setEditState] = useState("");
  const [editCity, setEditCity] = useState("");
  const [editZipCode, setEditZipCode] = useState("");
  const [editStreet, setEditStreet] = useState("");
  const [editApartment, setEditApartment] = useState("");
  const [editCountry, setEditCountry] = useState("");
  const [editAddressName, setEditAddressName] = useState("");
  const [saveEditsBtnText, setSaveEditsBtnText] = useState("Save");
  const [submittedQuoteType, setSubmittedQuoteType] = useState("Save");
  const [myDeliveryFocus, setMyDeliveryFocus] = useState({
    country: false,
    delivery: false,
  });
  const [newDeliveryFocus, setNewDeliveryFocus] = useState({
    country: false,
    delivery: false,
  });
  const countries = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [activeDropdown, setActiveDropdown] = useState(null);
    
  const getStates = (selectedCountry) =>  State.getStatesOfCountry(selectedCountry).map(state => ({
          label: state.name,
          value: state.isoCode
        }));
    
      const getCities = (selectedState, selectedCountry) => City.getCitiesOfState(selectedCountry, selectedState).map(city => ({
          label: city.name,
          value: city.name
        }));


    useEffect(() => {
        if (manualQuote.parsed && !manualQuote.clientData && !openOrderModel && !openQuoteModel) {
            transitionTo('/manualQuote/create')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [manualQuote]);


  useEffect(() => {
    setNotarization(manualQuote.notarization || false);
    setExpedited(manualQuote.expedited || false);
    setExpeditedPlus(
      getExpeditedPlusAvaliblity() ? manualQuote.expeditedPlus || false : false
    );
    setHardCopy(manualQuote.hardCopy || false);


    if (manualQuote.hardCopyExtra && manualQuote.hardCopyExtra.newAddress) {
      setHardCopyMethod(
        manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.method || "" : ""
      );
    } else {
      setSelectedMyMethod(
        manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.method || "" : ""
      );
    }
    setHardCopyCountry(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.country || "" : ""
    );
    setHardCopyFirstName(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.firstName || "" : ""
    );
    setHardCopyLastName(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.lastName || "" : ""
    );
    setHardCopyState(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.region || "" : ""
    );
    setHardCopyCity(manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.city || "" : "");
    setHardCopyZipCode(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.zipCode || "" : ""
    );
    setHardCopyStreet(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.street || "" : ""
    );
    setHardCopyApartment(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.apartment || "" : ""
    );
    setHardCopyRequireSignature(
      manualQuote.hardCopyExtra
        ? manualQuote.hardCopyExtra.requireSignature || false
        : false
    );
    if (manualQuote.hardCopyExtra && manualQuote.hardCopyExtra.saveAddress) {
      setSaveAddress(
        manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.saveAddress || false : false
      );
      setAddressName(
        manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.addressName || "" : ""
      );
    }

    setSelectedMyAddress(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.id || "" : ""
    );
    setNewAddressModal(
      manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.newAddress || "" : ""
    );

  }, [manualQuote]);


   useEffect(() => {
       if (
         signedIn &&
         manualQuote && manualQuote.clientTeamData &&
         manualQuote.clientTeamData.shipping &&
         manualQuote.clientTeamData.shipping.length > 0
       ) {
         if (selectedMyAddress !== "") {
           const addressSelected = manualQuote.clientTeamData.shipping.find(
             (address) => address.id === selectedMyAddress
           );
           if (addressSelected) {
             setSelectedMyAddress(addressSelected.id);
             setSelectedMyCountry(addressSelected.country);
   
             setHardCopyCountry(addressSelected.country);
             setHardCopyFirstName(addressSelected.firstName);
             setHardCopyLastName(addressSelected.lastName);
             setHardCopyState(addressSelected.region);
             setHardCopyCity(addressSelected.city);
             setHardCopyZipCode(addressSelected.zipCode);
             setHardCopyStreet(addressSelected.street);
             setHardCopyApartment(addressSelected.apartment);
             setAddressName(addressSelected.addressName);
           }
         } else {
           const address = manualQuote.clientTeamData.shipping.find(
             (address) => address.default === true
           );
           if (address) {
             setSelectedMyAddress(address.id);
             setSelectedMyCountry(address.country);
   
             setHardCopyCountry(address.country);
             setHardCopyFirstName(address.firstName);
             setHardCopyLastName(address.lastName);
             setHardCopyState(address.region);
             setHardCopyCity(address.city);
             setHardCopyZipCode(address.zipCode);
             setHardCopyStreet(address.street);
             setHardCopyApartment(address.apartment);
             setAddressName(address.addressName);
           }
         }
         setAddressName(
          manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.addressName || "" : ""
         );
         return;
       } 
       if (
        manualQuote && manualQuote.clientData &&
        manualQuote.clientData.shipping &&
        manualQuote.clientData.shipping.length > 0
       ) {
         if (selectedMyAddress !== "") {
           const addressSelected = manualQuote.clientData.shipping.find(
             (address) => address.id === selectedMyAddress
           );
           if (addressSelected) {
             setSelectedMyAddress(addressSelected.id);
             setSelectedMyCountry(addressSelected.country);
   
             setHardCopyCountry(addressSelected.country);
             setHardCopyFirstName(addressSelected.firstName);
             setHardCopyLastName(addressSelected.lastName);
             setHardCopyState(addressSelected.region);
             setHardCopyCity(addressSelected.city);
             setHardCopyZipCode(addressSelected.zipCode);
             setHardCopyStreet(addressSelected.street);
             setHardCopyApartment(addressSelected.apartment);
             setAddressName(addressSelected.addressName);
           }
         } else {
           const address = manualQuote.clientData.shipping.find(
             (address) => address.default === true
           );
           if (address) {
             setSelectedMyAddress(address.id);
             setSelectedMyCountry(address.country);
   
             setHardCopyCountry(address.country);
             setHardCopyFirstName(address.firstName);
             setHardCopyLastName(address.lastName);
             setHardCopyState(address.region);
             setHardCopyCity(address.city);
             setHardCopyZipCode(address.zipCode);
             setHardCopyStreet(address.street);
             setHardCopyApartment(address.apartment);
             setAddressName(address.addressName);
           }
         }
         setAddressName(
          manualQuote.hardCopyExtra ? manualQuote.hardCopyExtra.addressName || "" : ""
         );
         return;
       } 
         setNewAddressModal(true);
       // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [signedIn, manualQuote, selectedMyAddress]);

  useEffect(() => {
    if (hardCopy && hardCopyCountry === "") {
      setHardCopyMethod("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hardCopyCountry]);

  useEffect(() => {
    if (hardCopy && selectedMyAddress === "") {
      setSelectedMyMethod("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMyCountry]);

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };


  const phoneScreen =
    windowSize.orientation === "portrait" && windowSize.width <= 767;

  const getServicesTotal = () => {
    return (
      0 +
      (notarization ? 34.9 : 0) +
      (expeditedPlus || expedited
        ? getExpedited(manualQuote, false, expeditedPlus, expedited, false, getExpeditedServies(manualQuote))
        : 0) +
      (hardCopy
        ? getHardCopyPrice(
          newAddressModal ? hardCopyCountry : selectedMyCountry,
          newAddressModal ? hardCopyMethod : selectedMyMethod,
          false
        )
        : 0) +
      (hardCopy && hardCopyRequireSignature ? 4.99 : 0)
    );
  };

  const handleFocusDelivery = (isFocused) => {
    if (newAddressModal) {
      setNewDeliveryFocus({ delivery: isFocused, country: false });
    } else {
      setMyDeliveryFocus({ delivery: isFocused, country: false });
    }
  };

  const checkForHardCopyFields = () => {
    if (hardCopy) {
      if (
        newAddressModal
          ? hardCopyCountry === "" ||
          hardCopyMethod === "" ||
          hardCopyFirstName === "" ||
          hardCopyState === "" ||
          hardCopyCity === "" ||
          hardCopyZipCode === "" ||
          hardCopyStreet === "" ||
          hardCopyApartment === ""
          : selectedMyAddress === "" ||
          selectedMyCountry === "" ||
          selectedMyMethod === ""
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

   useEffect(() => {
      if (manualQuote.clientTeamData) {
          setDiscount(manualQuote.clientTeamData.discount || 0);
        }
    
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [manualQuote]);

  // const getHardCopyTotal = () => {
  //   return (
  //     (["United States", "Puerto Rico", "U.S. Virgin Islands"].includes(
  //       hardCopyCountry.label
  //     )
  //       ? hardCopyMethod === "priority"
  //         ? 19.95
  //         : 37.95
  //       : hardCopyMethod === "priority"
  //         ? 49.95
  //         : 78.95) + (hardCopyRequireSignature ? 4.99 : 0)
  //   );
    
  // };

  const getExpeditedPlusAvaliblity = () => {
    const date = new Date();
    const time = date
      .toLocaleString("en-US", { timeZone: "America/New_York" })
      .split(",")
      .pop();
    const day = time.split(" ").pop() === "AM" ? true : false;
    const hour = time.split(":")[0];

    // eslint-disable-next-line eqeqeq
    if ((!day && hour >= 5) || (day && (hour < 8 || hour == 12))) {
      return false;
    } else {
      return true;
    }
  };

  const getExpeditedPlusByLanguage = () => {
    if (
      expeditedPlusLanguages.includes(manualQuote.languageFrom) &&
      expeditedPlusLanguages.includes(manualQuote.languageTo)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getFullAddress = (address) => {
    const first = address.firstName ? address.firstName : address.recipient;
    const last =
      address.firstName && address.lastName ? " " + address.lastName : "";

    const name = first + last;

    return (
      name +
      ", " +
      address.country +
      ", " +
      address.region +
      ", " +
      address.city +
      ", " +
      address.zipCode +
      ", " +
      address.street +
      ", " +
      address.apartment
    );
  };

  const handleExpedited = () => {
    setExpeditedPlus(false);
    setExpedited((e) => !e);
  };

  const handleExpeditedPlus = () => {
    setExpedited(false);
    setExpeditedPlus((e) => !e);
  };

  const handleNotrization = () => {
    setNotarization((n) => !n);
  };

  const handleApplyCode = () => {
    setDiscountBtn("Applying...");
    // setApplingDiscount(true);
    
    try {
      firestore
        .collection("coupons")
        .where("code", "==", discountCode)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.docs.length > 0) {
            const doc = querySnapshot.docs[0];

            if (doc.data().uses > 0) {
              setDiscount(doc.data().discount);
              setAppliedCode(discountCode);
            } else {
              showNotification(
                "Error",
                "That code is no longer valid. Please, try another one.",
                "error"
              );
            }
          } else {
            showNotification(
              "Error",
              "That code doesn't exist. Please, try another one.",
              "error"
            );
          }
        });
    } catch (e) {
      showNotification(
        "Error",
        "There was an error applying the code. Please, try again.",
        "error"
      );
    } finally {
      setTimeout(() => {
        setDiscountBtn("Apply");
      }, 500);
    }
  };

  const checkTranslatorCertified = () => {
    return manualQuote.clientTeamData ? manualQuote.clientTeamData.individualTranslatorCertification??translatorCertify :translatorCertify;
   }

  // const handleSaveNewAddress = async (address) => {
    
  //   const newAddress = { default: false, ...address };
  //   const mShipping = userData.teamId && teamData ? teamData.shipping ? teamData.shipping.concat([newAddress]) : [newAddress] 
  //   : userData.shipping ? userData.shipping.concat([newAddress]) : [newAddress];

  //   await firestore
  //     .collection(userData.teamId && teamData ? "teams" :"users")
  //     .doc(userData.teamId && teamData ? userData.id : userData.id)
  //     .update({
  //       shipping: mShipping,
  //     })
  //     .then(() => { })
  //     .catch((error) => {
  //       showNotification(
  //         "Error",
  //         "An error ocurred while saving the address. Unfortunately, the address couldn't be saved.",
  //         "error"
  //       );
  //     });
  // };

  const getAddress = (addressID) => {
    if ( manualQuote.clientTeamData && manualQuote.clientTeamData.shipping && manualQuote.clientTeamData.shipping.length > 0) {
       return manualQuote.clientTeamData.shipping.find((a) => a.id === addressID)
    }else if (manualQuote.clientData && manualQuote.clientData.shipping && manualQuote.clientData.shipping.length > 0) {
      return manualQuote.clientData.shipping.find((a) => a.id === addressID)
    }
      return null;
  }

  const handleCreateQuote = async () => {
    setCreateQuoteText("Creating...");
    setIsLoading(true);
    setLoadingModal("quote");
    try {
      const now = new Date();
      
      let quoteNumber = 0;

      await getCounter("quote").then((number) => {
            quoteNumber = parseInt(number, 10);
            })
      .catch(() => { });

      if (quoteNumber === 0) {
        showNotification(
          "Error",
          "An error occurred while submitting the quote. Please, try again. If it persists, contact support.",
          "error"
        );
        return false;
      }

      const addressID = !newAddressModal ? selectedMyAddress : uuidv4();
      const country = newAddressModal ? hardCopyCountry.label : selectedMyCountry;
      const method = newAddressModal ? hardCopyMethod : selectedMyMethod;

      // const hardCopyAddress = ;
      const saveNewAddress = newAddressModal && saveAddress;
      const address = newAddressModal
        ? {
          id: addressID,
          country: country,
          addressName: addressName,
          firstName: hardCopyFirstName,
          lastName: hardCopyLastName,
          recipient: hardCopyFirstName + " " + hardCopyLastName,
          region: hardCopyState,
          city: hardCopyCity,
          zipCode: hardCopyZipCode,
          street: hardCopyStreet,
          apartment: hardCopyApartment,
          newAddress: newAddressModal
        }
        : getAddress(addressID);


      const saveNewAddressData = saveNewAddress ? address : "";

      // Generate a new document reference with an auto-generated ID
      const newQuoteID = uuidv4();
      const newQuoteRef = firestore.collection("quotes").doc(newQuoteID);
      // Remove undefined fields before setting the document
      const quoteData = {
        translatorCertification: checkTranslatorCertified(),
        expeditedServiceOption: getExpeditedServies(manualQuote),
        quoteID: newQuoteID,
        quoteNumber: quoteNumber,
        userID: manualQuote?.clientData?.id ?? "",
        teamId: manualQuote?.clientData?.teamId ?? "",
        email: manualQuote?.clientData?.email ?? "",
        firstName: manualQuote?.clientData?.firstName ?? "",
        lastName: manualQuote?.clientData?.lastName ?? "",
        name: `${manualQuote?.clientData?.firstName ? manualQuote?.clientData?.firstName + " " + manualQuote?.clientData?.lastName : manualQuote?.clientData?.name || ""
          }`,
        certified: manualQuote?.certified ?? false,
        languageFrom: manualQuote?.languageFrom ?? "",
        languageTo: manualQuote?.languageTo ?? "",
        notarization: notarization ?? false,
        expedited: expedited ?? false,
        expeditedPlus: expeditedPlus ?? false,
        hardCopy: hardCopy ?? null,
        hardCopyExtra: hardCopy
          ? {
            ...address,
            method: method ?? "",
            requireSignature: hardCopyRequireSignature ?? false,
          }
          : null,
        generalNotes: manualQuote?.generalNotes ?? "",
        notes: manualQuote?.generalNotes ?? "",
        files: (manualQuote?.files ?? []).map((file) => ({
          name: file?.name ?? "",
          id: file?.id ?? "",
          ref: file?.ref ?? "",
          url: file?.url ?? "",
          type: file?.type ?? "source",
          size: file?.size ?? 0,
          format: file?.format ?? "",
          timestamp: now.getTime(),
        })),
        timestamp: now.getTime(),
        status: "replied",
        discountApplied: discount > 0,
        discount: discount ?? 0,
        pagesCount: manualQuote.pagesCount,
        userNotes: "",
        clientFirstName: clientFirstName,
        clientLastName: clientLastName,
      };

      // Remove undefined fields before saving
      Object.keys(quoteData).forEach((key) => {
        if (quoteData[key] === undefined) delete quoteData[key];
      });

      await newQuoteRef.set(quoteData);

      // if (signedIn && userData && saveNewAddress) {
      //   handleSaveNewAddress(saveNewAddressData);
      // }

      
      if (appliedCode !== "") {
          axios
            .post(
                getFullHttpUrl("updateCouponUsage", EAST1),
                {
                    code: appliedCode,
                  }
                )
                .catch(() => { });
            }

      setStoreQuote({...quoteData,id: newQuoteID});
      setOpenQuoteModel(true);
      setLoadingModal("");
      setManualQuote({ parsed: true });
      localStorage.setItem(
        "manualQuote",
        JSON.stringify({ parsed: true })
      );
      setCreateQuoteText("Create Quote");
      setIsLoading(false);
    } catch (error) {
      setCreateQuoteText("Create Quote");
      setIsLoading(false);
      showNotification(
        "Error",
        "An error occurred while submitting the quote. Please, try again.",
        "error"
      );
    }
  };

  const handleQuotePopUpClick = (e) => {
    transitionTo(`/office/quote/${storeQuote.id}`, e);
    return setOpenQuoteModel(false);
  };

  const handleOrderPopUpClick = (e) => {
      transitionTo(`/office/translations/${storeOrder.id}`, e);
      return setOpenQuoteModel(false);
  };



  const handleCreateOrder = async () => {
    setCreateOrderText("Creating...");
    setIsLoading(true);
    setLoadingModal("order");
    try {
      const now = new Date();
      
      let orderNumber = 0;

      await getCounter("order").then((number) => {
        orderNumber = parseInt(number, 10);
        })
      .catch(() => { });

      if (orderNumber === 0) {
        showNotification(
          "Error",
          "An error occurred while submitting the quote. Please, try again. If it persists, contact support.",
          "error"
        );
        return false;
      }

      const getUserBilling = manuallyPaid ? "paid" : manualQuote.clientData.teamId && manualQuote.clientTeamData && manualQuote.clientTeamData.billingTerm &&
      manualQuote.clientTeamData.billingTerm !== "case-by-case" ?  "auto-billing" : "pay-later";

      const orderType = manualQuote.teamData ? "business" : "personal";

      const addressID = !newAddressModal ? selectedMyAddress : uuidv4();

      const country = newAddressModal ? hardCopyCountry : selectedMyCountry;

      // const hardCopyAddress = ;
      const saveNewAddress = newAddressModal && saveAddress;
      const address = newAddressModal
        ? {
          id: addressID,
          country: country,
          addressName: addressName,
          firstName: hardCopyFirstName,
          lastName: hardCopyLastName,
          recipient: hardCopyFirstName + " " + hardCopyLastName,
          region: hardCopyState,
          city: hardCopyCity,
          zipCode: hardCopyZipCode,
          street: hardCopyStreet,
          apartment: hardCopyApartment,
        }
        : getAddress(addressID);

      const saveNewAddressData = saveNewAddress ? address : "";

      // Generate a new document reference with an auto-generated ID
      const newOrderID = uuidv4();
      const newOrderRef = firestore.collection("orders").doc(newOrderID);
      // Remove undefined fields before setting the document
      const orderData = {
        translatorCertification: checkTranslatorCertified(),
        expeditedServiceOption: getExpeditedServies(manualQuote),
        type: orderType,
        id: newOrderID,
        orderNumber: orderNumber,
        userID: manualQuote?.clientData?.id ?? "",
        teamId: manualQuote?.clientData?.teamId ?? "",
        email: manualQuote?.clientData?.email ?? "",
        firstName: manualQuote?.clientData?.firstName ?? "",
        lastName: manualQuote?.clientData?.lastName ?? "",
         name: `${manualQuote?.clientData?.firstName ? manualQuote?.clientData?.firstName + " " + manualQuote?.clientData?.lastName : manualQuote?.clientData?.name || ""
          }`,
        certified: manualQuote?.certified ?? false,
        languageFrom: manualQuote?.languageFrom ?? "",
        languageTo: manualQuote?.languageTo ?? "",
        notarization: notarization ?? false,
        notarizationStatus: notarization ? "pending" : null,
        expedited: expedited ?? false,
        expeditedPlus: expeditedPlus ?? false,
        hardCopy: hardCopy ?? null,
        hardCopyStatus: hardCopy ? "pending" : null,
        hardCopyExtra: hardCopy
          ? {
            ...address,
            method: hardCopyMethod ?? "",
            requireSignature: hardCopyRequireSignature ?? false,
          }
          : null,
        pagesCount: manualQuote.pagesCount ? manualQuote.pagesCount : 0,
        wordCount: 0,
        notified: false,
        generalNotes: manualQuote?.generalNotes ?? "",
        notes: manualQuote?.generalNotes ?? "",
        files: (manualQuote?.files ?? []).map((file) => ({
          name: file?.name ?? "",
          id: file?.id ?? "",
          ref: file?.ref ?? "",
          url: file?.url ?? "",
          type: file?.type ?? "source",
          size: file?.size ?? 0,
          format: file?.format ?? "",
          timestamp: now.getTime(),
        })),
        timestamp: now.getTime(),
        paypalOrderID: getUserBilling,
        status: "new",
        discountApplied: discount > 0,
        discount: discount ? discount : 0,
        userNotes: "",
        clientFirstName: clientFirstName,
        clientLastName: clientLastName,
        orderPaidManually: manuallyPaid ? true :false,
        totalPrice: getTotal(
          manualQuote,
          false,
          false,
          notarization,
          expedited,
          expeditedPlus,
          hardCopy,
          newAddressModal ? hardCopyCountry : selectedMyCountry,
          newAddressModal ? hardCopyMethod : selectedMyMethod,
          hardCopyRequireSignature,
          getExpeditedServies(manualQuote)
        ),
      };

      // Remove undefined fields before saving
      Object.keys(orderData).forEach((key) => {
        if (orderData[key] === undefined) delete orderData[key];
      });

      await newOrderRef.set(orderData);

      // if (signedIn && userData && saveNewAddress) {
      //   handleSaveNewAddress(saveNewAddressData);
      // }

      if (appliedCode !== "") {
        axios
        .post(
          getFullHttpUrl("updateCouponUsage", EAST1),
          {
            code: appliedCode,
          }
        )
        .catch(() => { });
      }

      if(expedited || expeditedPlus){
        decrTeamFreeExpedOrder(manualQuote.clientData.teamId);
      }

      setStoreOrder({...orderData, id:newOrderID});
      setOpenOrderModel(true);
      setLoadingModal("");
      setManualQuote({ parsed: true });
      localStorage.setItem(
        "manualQuote",
        JSON.stringify({ parsed: true })
      );
      setCreateOrderText("Create Order");
      setIsLoading(false);
    } catch (error) {
      setCreateOrderText("Create Order");
      setIsLoading(false);
      console.log(error)
      showNotification(
        "Error",
        "An error occurred while submitting the Order. Please, try again.",
        "error"
      );
    }
  };

  const handleCloseQuoteModel = () => {
    setOpenQuoteModel(false);
  };
  const handleSendQuotePaymentLink = () => {
    setSelectedQuoteSendPayment(storeQuote);
  };

  const handleSendOrderPaymentLink = () => {
    setSelectedOrderSendPayment(storeOrder);
  };
  const handleCloseOrderModel = () => {
    setOpenOrderModel(false);
  };

  const handleMyAddressClick = () => {
    setNewAddressModal(false);
    setEditAddress("");
    setEditAddressIconSelected("");
    setNewDeliveryFocus({ delivery: false, country: false });
    setMyDeliveryFocus({ delivery: false, country: false });
  };

  const handleNewAddressClick = () => {
    setNewAddressModal(true);
    setEditAddress("");
    setEditAddressIconSelected("");
    setNewDeliveryFocus({ delivery: false, country: false });
    setMyDeliveryFocus({ delivery: false, country: false });
  };


  const getExpeditedServies = (data) => {
    return data && data.clientTeamData ? data.clientTeamData.expeditedServices || "paid" : "paid";
  }

  return (
    <>
      <animated.div
        style={statusOverlayProps}
        className="checkoutStatusOverlay"
      >
        {loadingModal === "quote"
          ? "We are finishing up the quote and redirecting you. This will take a second"
          : "We are finishing up the order and redirecting you. This will take a second"}<span className="dotsLoading">...</span>
      </animated.div>

      {selectedQuoteSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedQuoteSendPayment}
          type="quote"
          id={selectedQuoteSendPayment.id}
          onClose={() => setSelectedQuoteSendPayment("")}
        />
      )}

      {selectedOrderSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedOrderSendPayment}
          type="order"
          id={selectedOrderSendPayment.id}
          onClose={() => setSelectedOrderSendPayment("")}
        />
      )}
      {openQuoteModel &&
        (manualQuote &&
          manualQuote.clientTeamData && manualQuote.clientTeamData.billingTerm &&
          manualQuote.clientTeamData.billingTerm !== "case-by-case" ? (
          <>
            <PopUpModal
              title={"Quote Created"}
              btnText={"Go to Quotes"}
              sendIcon={true}
              onClick={(e) => handleQuotePopUpClick(e)}
            >
              {<QUOTESUCCESS />}
            </PopUpModal>
          </>
        ) : (
          <>
            <PopUpModal
              title={"Quote Created"}
              btnText={"Go to Quotes"}
              backBtnText={"Send Payment Link"}
              sendIcon={true}
              onClick={(e) => handleQuotePopUpClick(e)}
              onBackClick={() => handleSendQuotePaymentLink()}
              onClose={() => handleCloseQuoteModel()}
            >
              {<QUOTESUCCESS />}
            </PopUpModal>
          </>
        ))}

      {openOrderModel &&
        (manualQuote &&
          manualQuote.clientTeamData && manualQuote.clientTeamData.billingTerm &&
          manualQuote.clientTeamData.billingTerm !== "case-by-case" ? (
          <>
            <PopUpModal
              title={"Order Created"}
              btnText={"Go to Orders"}
              sendIcon={true}
              onClick={(e) => handleOrderPopUpClick(e)}
              onClose={() => handleCloseOrderModel()}
            >
              {<QUOTESUCCESS />}
            </PopUpModal>
          </>
        ) : (
          <PopUpModal
            title={"Order Created"}
            btnText={"Go to Orders"}
            backBtnText={"Send Payment Link"}
            sendIcon={true}
            onClick={(e) => handleOrderPopUpClick(e)}
            onBackClick={() => handleSendOrderPaymentLink()}
            onClose={() => handleCloseOrderModel()}
          >
            {<QUOTESUCCESS />}
          </PopUpModal>
        ))}
      <TopBar />

      <div className="mainOrderContainer">
        <div className="mainOrderHeader">
          <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
        </div>

        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <CreateOrderNav title="3. Services" stage={3} stages={3} />
            <div></div>
          </div>
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <div id="mainPrimary" className="mainOrderPrimaryContent">
              <div className="quotePrimaryOptionsWrapper">
                <h3 className="quotePrimaryTitle">Optional Services</h3>
                {manualQuote.certified ? (
                  <div
                    className="quoteOptionalContainer firstQuoteOptionalContainer"
                    onClick={() => handleNotrization()}
                    style={{
                      borderColor: notarization ? "#12ABBF" : "#E6E7E9",
                    }}
                  >
                    <div className="orderContentContainer">
                      <div className="orderIconWrapper">
                        <NOTRY className="icon" />
                      </div>
                      <div className="quoteOptionalTitleRow">
                        <div className="orderDetailsContainer">
                          <h5 className="orderPrimaryOptionTitle">
                            Notarization
                          </h5>
                          <p className="quotePrimaryOptionText">
                            Stamp and signature authenticating the translation
                            certification. Valid in all 50 states.
                          </p>
                        </div>
                        <div className="orderOptionalExtraContainer">
                          <p className="orderOptionalPrice">$34.90</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div
                  className={`quoteOptionalContainer ${manualQuote.certified ? "": "mt-4"}`}
                  onClick={() => handleExpedited()}
                  style={{ borderColor: expedited ? "#12ABBF" : "#E6E7E9" }}
                >
                  <div className="orderContentContainer">
                    <div className="orderIconWrapper">
                      <EXPEDITED className="icon" />
                    </div>
                    <div className="quoteOptionalTitleRow">
                      <div className="orderDetailsContainer">
                        <h5 className="orderPrimaryOptionTitle">
                          Expedited Turnaround
                        </h5>
                        <p className="quotePrimaryOptionText">
                          Your order will be prioritized and turnaround time for
                          digital delivery reduced by 50%.
                        </p>
                      </div>
                      <div className="orderOptionalExtraContainer">
                        <p className="orderOptionalPrice">{(getExpeditedServies(manualQuote) === "free-plus" || getExpeditedServies(manualQuote) === "free") ? "Free" : "$4.99/page" 
                        }</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="quoteOptionalContainer"
                  onClick={() => {
                    getExpeditedPlusAvaliblity() &&
                      getExpeditedPlusByLanguage() &&
                      handleExpeditedPlus();
                  }}
                  style={{
                    borderColor:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage() &&
                        expeditedPlus
                        ? "#12ABBF"
                        : "#E6E7E9",
                    opacity:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage()
                        ? 1
                        : 0.5,
                    cursor:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage()
                        ? "pointer"
                        : "default",
                  }}
                >
                  <div className="orderContentContainer">
                    <div className="orderIconWrapper">
                      <EXPEDITEDPLUS className="icon" />
                    </div>
                    <div className="quoteOptionalTitleRow">
                      <div className="orderDetailsContainer">
                        <h5 className="orderPrimaryOptionTitle">
                          Expedited Turnaround Plus
                        </h5>
                        <p className="quotePrimaryOptionText">
                          Your order will be prioritized and turnaround time for
                          digital delivery reduced by 83.33%.
                        </p>
                        {!(
                          getExpeditedPlusAvaliblity() &&
                          getExpeditedPlusByLanguage()
                        ) && (
                            <div className="expeditedPlusErrorWrap">
                              <p className="expeditedPlusErrorText">
                                {!getExpeditedPlusAvaliblity() &&
                                  getExpeditedPlusByLanguage()
                                  ? "Unavailable after 5 PM to 8 AM EST"
                                  : getExpeditedPlusAvaliblity() &&
                                    !getExpeditedPlusByLanguage()
                                    ? "Unavailable for non-Latin languages."
                                    : "Unavailable after 5 PM to 8 AM EST and for non-Latin languages."}
                              </p>
                            </div>
                          )}
                      </div>
                      <div className="orderOptionalExtraContainer">
                        <p className="orderOptionalPrice">{(getExpeditedServies(manualQuote) === "free-plus") ? "Free" : "$9.98/page" }</p>
                      </div>
                    </div>
                  </div>
                </div>
                {manualQuote.certified ? (
                  <div
                    className="quoteOptionalContainer"
                    style={{ borderColor: hardCopy ? "#12ABBF" : "#E6E7E9" }}
                  >
                    <div
                      className="orderContentContainer"
                      onClick={() => setHardCopy((n) => !n)}
                    >
                      <div className="orderIconWrapper">
                        <HARDCOPY className="icon" />
                      </div>
                      <div className="quoteOptionalTitleRow">
                        <div className="orderDetailsContainer">
                          <h5 className="orderPrimaryOptionTitle">
                            Mail Hard Copy
                          </h5>
                          <p className="quotePrimaryOptionText">
                            Original translation with wet ink signature(s)
                            shipped via USPS Priority or Express mail.
                          </p>
                        </div>
                        <div className="orderOptionalExtraContainer">
                          <p className="orderOptionalPrice">
                            {hardCopy &&
                              hardCopyCountry !== "" &&
                              hardCopyMethod !== "" &&
                              formatTotal(getHardCopyPrice(hardCopyCountry.label,hardCopyMethod, hardCopyRequireSignature, manualQuote))}
                          </p>
                        </div>
                      </div>
                    </div>

                    {hardCopy &&
                    signedIn &&
                    manualQuote.clientTeamData &&
                    (manualQuote.clientTeamData.shipping &&
                    manualQuote.clientTeamData.shipping.length > 0)? (
                      <div className="hardCopyAddressTabWrap">
                        <div
                          className="hardCopyAddressTab"
                          onClick={handleMyAddressClick}
                        >
                          <div
                            className="hardCopyAddressTabText"
                            style={{
                              borderBottomWidth: !newAddressModal ? "2px" : 0,
                            }}
                          >
                            My Address
                          </div>
                        </div>
                        <div
                          className="hardCopyAddressTab"
                          onClick={handleNewAddressClick}
                        >
                          <div
                            className="hardCopyAddressTabText"
                            style={{
                              borderBottomWidth: newAddressModal ? "2px" : 0,
                            }}
                          >
                            New Address
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {hardCopy ? (
                      manualQuote &&
                      !newAddressModal ? (
                        <>
                          {manualQuote.clientTeamData && manualQuote.clientTeamData.shipping && manualQuote.clientTeamData.shipping.length > 0 &&
                          manualQuote.clientTeamData.shipping.map((address, i) => (
                            <div
                              key={address.id}
                              className="hardCopyAddressContainer"
                              style={{
                                borderColor:
                                  selectedMyAddress === address.id
                                    ? "#12ABBF"
                                    : "#E6E7E9",
                              }}
                            >
                              <div className="quoteOptionalTitleRow">
                                <div
                                  className="hardCopyAddressDetails"
                                  onClick={() =>
                                    setSelectedMyAddress(address.id)
                                  }
                                >
                                  <h6 className="hardCopyAddressTitle">
                                    {address.addressName
                                      ? address.addressName
                                      : address.recipient}{" "}
                                    <span>
                                      {address.default && "(primary)"}
                                    </span>
                                  </h6>
                                  <p className="hardCopyAddressText">
                                    {getFullAddress(address)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))}
                          {manualQuote.clientData && manualQuote.clientData.shipping && manualQuote.clientData.shipping.length > 0 &&
                          manualQuote.clientData.shipping.map((address, i) => (
                            <div
                              key={address.id}
                              className="hardCopyAddressContainer"
                              style={{
                                borderColor:
                                  selectedMyAddress === address.id
                                    ? "#12ABBF"
                                    : "#E6E7E9",
                              }}
                            >
                              <div className="quoteOptionalTitleRow">
                                <div
                                  className="hardCopyAddressDetails"
                                  onClick={() =>
                                    setSelectedMyAddress(address.id)
                                  }
                                >
                                  <h6 className="hardCopyAddressTitle">
                                    {address.addressName
                                      ? address.addressName
                                      : address.recipient}{" "}
                                    <span>
                                      {address.default && "(primary)"}
                                    </span>
                                  </h6>
                                  <p className="hardCopyAddressText">
                                    {getFullAddress(address)}
                                  </p>
                                </div>
                              </div>

                            </div>
                          ))}
                          <div className="quoteDetailsInputsContainer">
                            <div className="quoteDetailsSelectContainer sm:w-1/2 w-full">
                              <SearchSelect
                                list={
                                  selectedMyCountry
                                    ? [
                                      "United States",
                                      "Puerto Rico",
                                      "U.S. Virgin Islands",
                                    ].includes(selectedMyCountry)
                                      ? USPriorDelivery
                                      : otherCitiesDelivery
                                    : []
                                }
                                placeholder="Delivery"
                                value={selectedMyMethod}
                                focus={myDeliveryFocus.delivery}
                                setValue={setSelectedMyMethod}
                                setFocus={handleFocusDelivery}
                              />
                            </div>
                          </div>

                          <div
                            className="hardCopyCheckboxLine"
                            onClick={() =>
                              setHardCopyRequireSignature((hc) => !hc)
                            }
                          >
                            <div
                              className={`${hardCopyRequireSignature && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{
                                  opacity: hardCopyRequireSignature ? 1 : 0,
                                }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">
                              Require signature for delivery $4.99
                            </p>
                          </div>
                        </>
                      ) : (
                        <div className="editInputsContainer">
                          {/* <div className="hardCopyLineSeparator" /> */}
                          <div className="grid sm:grid-cols-2 grid-cols-1 items-center md:gap-3 gap-2 w-full">
                            {/* <SearchSelect
                            list={countries}
                            placeholder="Country"
                            value={hardCopyCountry}
                            focus={newDeliveryFocus.country}
                            setValue={setHardCopyCountry}
                            setFocus={handleFocusCountry}
                            isLabeled={false}
                          /> */}
                            <SelectSearch
                              placeholder="Select Country"
                              value={hardCopyCountry? hardCopyCountry.value : ""}
                              setValue={(val) => setHardCopyCountry(countries.find(c => c.value === val))}
                              list={countries}
                              activeDropdown={activeDropdown}
                              setActiveDropdown={setActiveDropdown}
                              dropdownId="country"
                            />
                            <SearchSelect
                              list={
                                hardCopyCountry
                                  ? [
                                    "United States",
                                    "Puerto Rico",
                                    "U.S. Virgin Islands",
                                  ].includes(hardCopyCountry.label)
                                    ? USPriorDelivery
                                    : otherCitiesDelivery
                                  : []
                              }
                              placeholder="Delivery"
                              value={hardCopyMethod}
                              focus={newDeliveryFocus.delivery}
                              setValue={setHardCopyMethod}
                              setFocus={handleFocusDelivery}
                            />
                          </div>

                          <div className="grid sm:grid-cols-2 grid-cols-1 items-center md:gap-3 gap-2 w-full">
                            <FormTextInput
                              placeholder={"First Name"}
                              value={hardCopyFirstName}
                              onChange={setHardCopyFirstName}
                            />
                            <FormTextInput
                              placeholder={"Last Name"}
                              value={hardCopyLastName}
                              onChange={setHardCopyLastName}
                            />
                          </div>

                            <div className="quoteDetailsInputsContainer">
                              <SelectSearch
                                placeholder="Select State"
                                value={hardCopyState ? hardCopyState.value : ""}
                                setValue={(val) => setHardCopyState(getStates(hardCopyCountry.value).find(s => s.value === val))}
                                list={getStates(hardCopyCountry.value)}
                                activeDropdown={activeDropdown}
                                setActiveDropdown={setActiveDropdown}
                                dropdownId="state"
                                disabled={!hardCopyCountry.value}
                              />
                              <SelectSearch
                                placeholder="Select City"
                                value={hardCopyCity ? hardCopyCity.value : ""}
                                setValue={(val) =>setHardCopyCity(getCities(hardCopyState.value,hardCopyCountry.value).find(c => c.value === val))}
                                list={getCities(hardCopyState.value,hardCopyCountry.value)}
                                activeDropdown={activeDropdown}
                                setActiveDropdown={setActiveDropdown}
                                dropdownId="city"
                                disabled={!hardCopyCountry.value || !hardCopyState.value}
                              />
    
                                <FormTextInput
                                  placeholder={"ZIP code"}
                                  value={hardCopyZipCode}
                                  onChange={setHardCopyZipCode}
                                />
                            </div>
                          <div className="quoteDetailsInputsContainer">
                            <FormTextInput
                              placeholder={"Street/Address"}
                              value={hardCopyStreet}
                              onChange={setHardCopyStreet}
                            />
                          </div>
                          <div className="quoteDetailsInputsContainer">
                            <FormTextInput
                              placeholder={"Apartment, suite, etc."}
                              value={hardCopyApartment}
                              onChange={setHardCopyApartment}
                            />
                          </div>
                          <div
                            className="hardCopyCheckboxLine"
                            onClick={() =>
                              setHardCopyRequireSignature((hc) => !hc)
                            }
                          >
                            <div
                              className={`${hardCopyRequireSignature && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{
                                  opacity: hardCopyRequireSignature ? 1 : 0,
                                }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">
                              Require signature for delivery $4.99
                            </p>
                          </div>
                          {/* {userData && <div
                            className="hardCopyCheckboxLine"
                            onClick={() => setSaveAddress((hc) => !hc)}
                          >
                            <div
                              className={`${saveAddress && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{ opacity: saveAddress ? 1 : 0 }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">Save address</p>
                          </div>} */}
                          {saveAddress ? (
                            <div className="quoteDetailsInputsContainer">
                              <FormTextInput
                                placeholder={"Address Name"}
                                value={addressName}
                                onChange={setAddressName}
                              />
                            </div>
                          ) : null}
                        </div>
                      )
                    ) : null}
                  </div>
                ) : null}

                <div
                  className="quoteOptionalContainer"
                  onClick={() => setTranslatorCertify(n => !n)}
                  style={{ borderColor: (checkTranslatorCertified()) ? "#12ABBF" : "#E6E7E9" }}
                >
                  <div className="orderContentContainer !items-center">
                    <div className="orderIconWrapper">
                      <NOTRY className="icon" />
                    </div>
                    <div className="quoteOptionalTitleRow">
                      <div className="orderDetailsContainer">
                        <h5 className="orderPrimaryOptionTitle">
                        Individual Translator's Certification
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="quoteOptionalContainer"
                  onClick={() => setManuallyPaid(n => !n)}
                  style={{ borderColor: manuallyPaid ? "#12ABBF" : "#E6E7E9" }}
                >
                  <div className="orderContentContainer !items-center">
                    <div className="orderIconWrapper">
                      <CHECK className="icon" />
                    </div>
                    <div className="quoteOptionalTitleRow">
                      <div className="orderDetailsContainer">
                        <h5 className="orderPrimaryOptionTitle">
                        Manually Paid
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {manualQuote.clientTeamData && <div className="quotePrimaryOptionsWrapper">
                <h3 className="quotePrimaryTitle">
                  Your Client{" "}
                  <span style={{ color: "#9A9FA7", fontWeight: 500 }}>
                    {"(optional)"}
                  </span>
                </h3>
                <p
                  className="quotePrimaryOptionText"
                  style={{ marginBottom: "1rem" }}
                >
                  If submitted, the client field will be included in emails, in
                  translations, and in your invoice.
                </p>
                <div className="quoteDetailsInputsContainer">
                  <FormTextInput
                    placeholder={"Client First Name"}
                    value={clientFirstName}
                    onChange={setClientFirstName}
                  />
                  <FormTextInput
                    placeholder={"Client Last Name"}
                    value={clientLastName}
                    onChange={setClientLastName}
                  />
                </div>
              </div>}

              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">Discount Code</h4>

                <div className="quoteDiscountTab">
                  <div className="quoteDiscountcontainer">
                    <FormTextInput
                      placeholder={"Discount code"}
                      value={discountCode}
                      onChange={setDiscountCode}
                      discountIcon={discount > 0}
                      discountIconText={`${discount}%`}
                    />
                    <NewButton
                      text={discountBtn}
                      disabled={discountBtn === "Applying..."}
                      back={true}
                      icon={false}
                      onClick={() => handleApplyCode()}
                      whiteBtn={true}
                    />
                  </div>
                </div>
              </div>

              <div>
                {!phoneScreen && (
                  <div className="quoteSubmitButtonContainer justifyEnd">
                    <NewButton
                      text="Back to Details"
                      onClick={(e) =>
                        transitionTo("/manualQuote/details", e)
                      }
                      back={true}
                    />
                    {/* <NewButton text={continueButton} disabled={(!quote.type) || quote.languageFrom === '' || checkForHardCopyFields() || (hardCopy && saveAddress && addressName === "")} onClick={() => handleContinueToPayment()}/> */}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="mainOrderSecondaryContent">
            <div className="mainOrderSecondaryContentWrap">
              <div className="orderSummary">
                <h2 className="orderSummaryTitle">SUMMARY</h2>
                <div className="orderSummaryInfoWrapper">
                  <div className="orderSummaryInfo">
                    <h4 className="orderSummaryInfoType">
                      {manualQuote.certified
                        ? "Certified Translation"
                        : "Standard Translation"}
                    </h4>
                    <h4 className="orderSummaryInfoType">
                      {manualQuote.pagesCount !== ""
                        ? "$" + getOrderPageCountTotal(manualQuote).toFixed(2)
                        : "$0.00"}
                    </h4>
                  </div>
                  <p className="orderSummaryInfoCount">
                    {manualQuote.pagesCount !== ""
                      ? manualQuote.pagesCount +
                      " pages (" +
                      parseInt(manualQuote.pagesCount, 10) * 250 +
                      " words max)"
                      : "0 pages (0 words max)"}
                  </p>
                  {manualQuote.languageFrom && manualQuote.languageTo && (
                    <p className="orderSummaryInfoCount">
                      {getLanguage(manualQuote.languageFrom)} to{" "}
                      {getLanguage(manualQuote.languageTo)}
                    </p>
                  )}
                </div>

                {notarization ||
                  expedited ||
                  expeditedPlus ||
                  (hardCopy &&
                    (newAddressModal
                      ? hardCopyCountry !== ""
                      : selectedMyCountry !== "") &&
                    (newAddressModal
                      ? hardCopyMethod !== ""
                      : selectedMyMethod !== "")) ||
                  (hardCopy && hardCopyRequireSignature) ? (
                  <div className="orderSummaryInfoWrapper">
                    <div className="orderSummaryInfo">
                      <h4 className="orderSummaryInfoType">Services</h4>
                      <h4 className="orderSummaryInfoType">
                        {getServicesTotal() === 0
                          ? "Free"
                          : formatTotal(getServicesTotal())}
                      </h4>
                    </div>
                    {notarization ? (
                      <div className="orderSummaryInfo">
                        <p className="orderSummaryInfoCount">Notarization</p>
                        <p className="orderSummaryInfoCount">$34.90</p>
                      </div>
                    ) : null}
                    {expeditedPlus || expedited ? (
                      <div className="orderSummaryInfo">
                        <p className="orderSummaryInfoCount">
                          {manualQuote.expeditedPlus ? "Expedited+" : "Expedited"}{" "}
                          Turnaround
                        </p>
                        <p className="orderSummaryInfoCount">
                          {formatTotal(
                            getExpedited(manualQuote, false, expeditedPlus, expedited, false, getExpeditedServies(manualQuote))
                          )}
                        </p> 
                      </div>
                    ) : null}
                    {hardCopy &&
                      (newAddressModal
                        ? hardCopyCountry !== ""
                        : selectedMyCountry !== "") &&
                      (newAddressModal
                        ? hardCopyMethod !== ""
                        : selectedMyMethod !== "") ? (
                      <div className="orderSummaryInfo">
                        <p className="orderSummaryInfoCount">Mail Hard Copy</p>
                        <p className="orderSummaryInfoCount">
                          {formatTotal(
                            getHardCopyPrice(
                              newAddressModal
                                ? hardCopyCountry.label
                                : selectedMyCountry,
                              newAddressModal
                                ? hardCopyMethod
                                : selectedMyMethod,
                              false
                            )
                          )}
                        </p>
                      </div>
                    ) : null}
                    {hardCopy && hardCopyRequireSignature ? (
                      <div className="orderSummaryInfo">
                        <p className="orderSummaryInfoCount">
                          Signature Required for Delivery
                        </p>
                        <p className="orderSummaryInfoCount">$4.99</p>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                <div className="orderSummaryTotal">
                  <h4>Discount</h4>
                  <h4>
                    -{formatTotal(getDiscount(manualQuote, false, discount, false) || 0)}
                  </h4>
                </div>
                <div className="orderSummaryTotal">
                  <h4>Total</h4>
                  <h4>
                    {formatTotal(
                      getTotal(
                        manualQuote,
                        false,
                        false,
                        notarization,
                        expedited,
                        expeditedPlus,
                        hardCopy,
                        newAddressModal ? hardCopyCountry.label : selectedMyCountry,
                        newAddressModal ? hardCopyMethod : selectedMyMethod,
                        hardCopyRequireSignature,
                        getExpeditedServies(manualQuote)
                      ) - getDiscount(manualQuote, false, discount, false) || 0
                    )}
                  </h4>
                </div>

                <div className="summryButttons">
                  <NewButton
                    text={createQuoteText}
                    width="100%"
                    onClick={() => handleCreateQuote()}
                    disabled={
                      checkForHardCopyFields() ||
                      (hardCopy && saveAddress && addressName === "")||
                      !manualQuote.clientData ||
                      createQuoteText === "Creating..."
                    }
                  />
                  <NewButton
                    text={createOrderText}
                    back
                    icon={false}
                    whiteBtn
                    width="100%"
                    onClick={() => handleCreateOrder()}
                    disabled={
                      !manualQuote.clientData ||
                      checkForHardCopyFields() ||
                      (hardCopy && saveAddress && addressName === "")||
                      createQuoteText === "Creating..."
                    }
                  />
                </div>
              </div>

              {phoneScreen && (
                <div className="quoteSubmitButtonContainer justifyEnd">
                  <NewButton
                    text="Back to Details"
                    onClick={(e) =>
                      transitionTo("/manualQuote/details", e)
                    }
                    back={true}
                    icon={true}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuoteService;
